/**
 * Query keys del dominio Administración (sedes + atendidos).
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos):
 *  - **Sedes** es el catálogo GLOBAL del admin (el backend no exige `X-Sede-Id`):
 *    sus keys NO incluyen la sede activa (los datos son los mismos en cualquier
 *    sede), igual que el dominio Equipo.
 *  - **Atendidos** está acotado por la sede activa (el backend filtra por
 *    `X-Sede-Id`): la key incluye la sede para CACHEAR POR SEDE. Al cambiar de
 *    sede, el listado se recarga (clave distinta) en vez de mostrar el de la
 *    sede anterior, igual que el dominio Talonarios.
 *  - **Precios del cotizador** es config GLOBAL en disco (el backend NO usa sede
 *    para estos endpoints): su key NO incluye la sede, igual que Sedes.
 */

/** Raíz de todas las queries de sedes (para invalidación amplia). */
export const SEDES_ROOT_KEY = ["admin-sedes"] as const;

/**
 * Raíz de la query de precios del cotizador. NO se segmenta por sede: los precios
 * son globales (un JSON en disco; el backend no resuelve sede aquí). Se usa tanto
 * como `queryKey` como para invalidar tras guardar.
 */
export const PRECIOS_ROOT_KEY = ["admin-precios"] as const;

/** Raíz de todas las queries de atendidos (para invalidación amplia). */
export const ATENDIDOS_ROOT_KEY = ["admin-atendidos"] as const;

/** Key de la lista de sedes con estadísticas. */
export const sedesListQueryKey = () => ["admin-sedes", "list"] as const;

/** Key del detalle de una sede. */
export const sedeDetailQueryKey = (sedeId: number) =>
  ["admin-sedes", "detail", sedeId] as const;

/** Key de la lista de atendidos de la sede, segmentada por sede activa. */
export const atendidosListQueryKey = (sedeId: number | null) =>
  ["admin-atendidos", "list", { sede: sedeId }] as const;

/** Key del detalle de un atendido, segmentada por sede activa. */
export const atendidoDetailQueryKey = (sedeId: number | null, atendidoId: number) =>
  ["admin-atendidos", "detail", { sede: sedeId, atendidoId }] as const;
